import {
  ANDROID_APP_DETAILS_SUCCESS,
  ANDROID_APP_RECOMMEND_SUCCESS,
  ANDROID_APP_STE_SHOW_QRCODE,
  ANDROID_APP_GROUP_SUCCESS,
  ANDROID_APP_GIFT_SUCCESS,
  ANDROID_APP_GIFT_RECEIVE_SUCCESS,
} from '../constants/adetail';

const initState = {
  appDetails: {},
  apps: [],
  appRecommend: {},
  showQRCode: false,
  detailGroups: null,
  detailGift: {},
  receiveGift: {},
};

const adetail = (state = initState, action = {}) => {
  switch (action.type) {
    case ANDROID_APP_DETAILS_SUCCESS:
      return { ...state, appDetails: action.payload };
    case ANDROID_APP_RECOMMEND_SUCCESS:
      return { ...state, appRecommend: action.payload };
    case ANDROID_APP_STE_SHOW_QRCODE:
      return { ...state, showQRCode: action.visible };
    case ANDROID_APP_GROUP_SUCCESS:
      return { ...state, detailGroups: action.payload };
    case ANDROID_APP_GIFT_SUCCESS:
      return { ...state, detailGift: action.payload };
    case ANDROID_APP_GIFT_RECEIVE_SUCCESS:
      return { ...state, receiveGift: action.payload };
    default:
      return state;
  }
};

export default adetail;
